import React from 'react';
import Icon from './Icon';

const ForestIcon = (props) => (
    <Icon {...props}>
        <path
            d="M2 21H22M4.5 16C2.5 16 1.5 13.5 2.5 11.5C1.8 9 4 6.5 6.5 6.5C8 4.5 10.5 4.5 11.5 6.5C13 8 13 10.5 12 12C13 14 11.5 16 9.5 16H4.5ZM7 16V21M17.5 3.5L14 9.5H16L13 16.5H16.5V21H18.5V16.5H22L19 9.5H21L17.5 3.5Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default ForestIcon;
